<template>
  <!--  v-if="$store.state.auth.checkAccess({key: 'document_link', value: true})" -->
  <v-container class="pa-0">
    <v-data-table
      v-if="$store.state.auth.checkAccess({key: 'document_link', value: true})"
      :headers="headers"
      :items="activeAccount.kyc.automatic.items"
      sort-by="created"
      dense
      sort-desc
      calculate-widths
      height="368"
      :loading="activeAccount.kyc.automatic.loading"
      :footer-props="{'items-per-page-options': [-1]}"
      :items-per-page="-1"
    >
      <template v-slot:item.state="{ item }">
        <v-chip class="my-1" small :color="get(colorMap, get(item, 'state'), colorMap.default)">{{ get(item, 'state') }}</v-chip>
      </template>
      <template v-slot:item.view="{ item }">
        <v-btn
          x-small
          dark
          color="info"
          @click="dialog = item"
        >
          Details
        </v-btn>
      </template>
      <template v-slot:item.description="{ item }">
        <template v-if="isArray(item.decline_reason)" v-for="(reason, i) of item.decline_reason">
          <br v-if="i != 0" />
          {{ reason }}
        </template>
        <template v-else>
          {{ item.decline_reason }}
        </template>
      </template>
    </v-data-table>


    <!--    <v-dialog-->
    <!--      v-model="proofImg"-->
    <!--      scrollable-->
    <!--      max-width="50vw"-->
    <!--      v-if="proofImg"-->
    <!--    >-->
    <!--      <img :src="" width="100%" height="100%" />-->
    <!--    </v-dialog>-->
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="60vw"
      v-if="dialog"
    >
      <v-card class="shuftipro-dialog">
        <v-card-title>ID: {{ dialog.request_id }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 70vh;">
          <v-simple-table class="mt-1">
            <template v-slot:default>
              <tbody>
                <tr>
                  <th>State:</th>
                  <td>
                    <v-chip small :color="get(colorMap, get(dialog, 'state'), colorMap.default)">{{ get(dialog, 'state') }}</v-chip>
                  </td>
                  <th>Created:</th>
                  <td>{{ get(dialog, 'created') }}</td>
                  <th>Updated:</th>
                  <td>{{ get(dialog, 'updated') }}</td>
                </tr>
              </tbody>
              <caption v-if="dialog.decline_reason && dialog.decline_reason.join('').length > 0">
                <material-notification
                  class="mb-3"
                  color="warning"
                  v-html="isArray(dialog.decline_reason) ? dialog.decline_reason.join('<br/>') : dialog.decline_reason"
                />
              </caption>
            </template>
          </v-simple-table>

          <template v-if="dialog.driver == 'shuftipro'">
            <v-row>
              <v-col cols="6">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th colspan="2"><h3>Browser Info</h3></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Browser</td>
                        <td>{{ get(dialog, 'info.agent.browser_name') }}</td>
                      </tr>
                      <tr>
                        <td>Platform</td>
                        <td>{{ get(dialog, 'info.agent.platform_name') }}</td>
                      </tr>
                      <tr>
                        <td>Device Name</td>
                        <td>{{ get(dialog, 'info.agent.device_name') }}</td>
                      </tr>
                      <tr>
                        <td>Device Type</td>
                        <td>
                          <template v-if="get(dialog, 'info.agent.is_desktop')">Desktop</template>
                          <template v-if="get(dialog, 'info.agent.is_phone')">Phone</template>
                        </td>
                      </tr>
                      <tr>
                        <td>IP</td>
                        <td>{{ get(dialog, 'info.geolocation.ip') }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="6">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th colspan="2"><h3>Geo Location</h3></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Country</td>
                        <td>{{ get(dialog, 'info.geolocation.country_name') }}</td>
                      </tr>
                      <tr>
                        <td>City</td>
                        <td>{{ get(dialog, 'info.geolocation.city') }}</td>
                      </tr>
                      <tr>
                        <td>Region Code</td>
                        <td>{{ get(dialog, 'info.geolocation.region_name') }}</td>
                      </tr>
                      <tr>
                        <td>Postal Code</td>
                        <td>{{ get(dialog, 'info.geolocation.postal_code') }}</td>
                      </tr>
                      <tr>
                        <td>Timezone</td>
                        <td>{{ get(dialog, 'info.geolocation.timezone') }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Services</th>
                    <th>Verified Steps</th>
                    <th>Not verified Steps</th>
                    <th>Not Applicable</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(v, k) in dialog.data">
                    <th class="vertical-align-top">
                      {{ beautifyStr(k) }}<br />
                      <v-btn
                        v-if="canViewProof && v.proof"
                        x-small
                        color="info"
                        :loading="loadingProof"
                        :disabled="loadingProof"
                        @click="getProofLink(dialog.request_id, k)"
                      >Photo
                      </v-btn>
                    </th>
                    <td class="vertical-align-top">
                      <ul>
                        <li v-for="(r, j) in v.result" v-if="!isNull(r) && r">
                          <v-icon left color="success">mdi-check-circle</v-icon>
                          <template v-if="j == 'selected_type'">Document Type</template>
                          <template v-else>{{ beautifyStr(j) }}</template>
                        </li>
                      </ul>
                    </td>
                    <td class="vertical-align-top">
                      <ul>
                        <li v-for="(r, j) in v.result" v-if="!isNull(r) && !r">
                          <v-icon left color="error">mdi-close-circle-outline</v-icon>
                          <template v-if="j != 'selected_type'">{{ beautifyStr(j) }}</template>
                          <template v-else>{{ beautifyStr(v.supported_types[r]) }}</template>
                        </li>
                      </ul>
                    </td>
                    <td class="vertical-align-top">
                      <ul>
                        <li v-for="(r, j) in v.result" v-if="isNull(r)">
                          <v-label>N/A</v-label>
                          {{ beautifyStr(j) }}
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
                <caption style="caption-side: top; text-align: left;">
                  <h3>Processed Services and Steps</h3>
                </caption>
              </template>
            </v-simple-table>
          </template>
          <template v-if="dialog.driver == 'sumsub'">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Services</th>
                    <th>State</th>
                    <th>Comment</th>
                    <th>Proof</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(v, k) in dialog.data">
                    <td class="py-1">
                      <template v-if="k != v.idDocType">{{ k }}:</template>
                      {{ v.idDocType }}<br />
                      <v-label>{{ v.country }}</v-label>
                    </td>
                    <td class="py-1">
                      <v-chip small :color="(get(v, 'reviewResult.reviewAnswer') == 'GREEN') ? 'green lighten-4' : 'red lighten-4'">{{ get(v, 'reviewResult.reviewAnswer') }}</v-chip>
                    </td>
                    <td style="white-space: normal">
                      {{ get(v, 'reviewResult.moderationComment') }}
                    </td>
                    <td class="py-1" style="min-width: 160px">

                      <ul>
                        <li v-for="(r, j) in v.imageReviewResults" v-if="!isNull(r)">
                          <v-tooltip
                            v-if="r.moderationComment"
                            bottom
                            content-class="bottom"
                          >
                            <template v-slot:activator="{ attrs, on }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                small
                                :color="(r.reviewAnswer == 'GREEN') ? 'green lighten-4' : 'red lighten-4'">
                                {{ r.reviewAnswer }}
                              </v-chip>
                            </template>
                            <div>{{ r.moderationComment }}</div>
                          </v-tooltip>
                          <v-chip
                            v-else
                            small
                            :color="(r.reviewAnswer == 'GREEN') ? 'green lighten-4' : 'red lighten-4'">
                            {{ r.reviewAnswer }}
                          </v-chip>
                          <v-btn
                            v-if="canViewProof"
                            x-small
                            color="info"
                            class="float-right"
                            :loading="loadingProof"
                            :disabled="loadingProof"
                            @click="getProofLink(dialog.request_id, j)"
                          >Photo
                          </v-btn>
                        </li>
                      </ul>

                    </td>
                  </tr>
                </tbody>
                <caption style="caption-side: top; text-align: left;">
                  <h3>Processed Services and Steps</h3>
                </caption>
              </template>
            </v-simple-table>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>


  </v-container>
</template>

<style>
  .vertical-align-top {
    vertical-align: top;
  }

  .shuftipro-dialog tbody th,
  .shuftipro-dialog tbody td {
    white-space: nowrap;
    /*vertical-align: top;*/
  }

  .shuftipro-dialog tbody tr:hover {
    background-color: transparent !important;
  }

  .shuftipro-dialog caption {
    caption-side: bottom;
  }

  .shuftipro-dialog ul {
    padding-left: 0;
  }

  .shuftipro-dialog li {
    list-style: none;
  }

  .shuftipro-dialog .v-label {
    font-size: 12px;
  }

</style>

<script>
  import { startCase, capitalize, get, isNull, isArray } from 'lodash'
  import { mapGetters } from 'vuex'
  import { API } from '@/utils/api'

  export default {
    props: [],

    data: () => ({
      proofImg: false,
      dialog: false,
      colorMap: {
        'verification.accepted': 'green lighten-4',
        'verification.pending': 'blue-grey lighten-2',
        'verification.decline': 'red lighten-4',
        'GREEN': 'green lighten-4',
        'RED': 'red lighten-4',
        default: 'grey lighten-2'
      },
      headers: [
        { text: 'Date', value: 'updated' },
        { text: 'ID', value: 'request_id' },
        { text: 'State', value: 'state' },
        { text: 'Description', align: 'left', sortable: false, value: 'description' },
        { text: '#', align: 'left', sortable: false, value: 'view' },
      ],
      loading: false,
      loadingProof: false
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active' }),
      canViewProof() {
        return this.$store.state.auth.checkAccess({key: 'kyc', value: true})
      },
    },

    methods: {
      isNull,
      isArray,
      startCase,
      capitalize,
      get,
      beautifyStr (str) {
        return startCase((str || '').toLowerCase())
      },
      getProofLink (requestId, type) {
        this.loadingProof = true
        API.call('/$v/account/kyc/get_proof.json', {
          login: this.activeAccount.account.login,
          request_id: requestId,
          type
        }, this.activeAccount.account).then(resp => resp.data).then(r => {

          if (r.url.match(/^data/)) {

            if (window.URL) {

              function base64ToArrayBuffer (_base64Str) {
                let binaryString = window.atob(_base64Str)
                let binaryLen = binaryString.length
                let bytes = new Uint8Array(binaryLen)
                for (let i = 0; i < binaryLen; i++) {
                  let ascii = binaryString.charCodeAt(i)
                  bytes[i] = ascii
                }
                return bytes
              }

              let data = r.url.match(/data:(.*)?;base64,(.*)?/)

              let byte = base64ToArrayBuffer(data[2])

              let blob = new Blob([ byte ], { type: data[1] })

              window.open(window.URL.createObjectURL(blob), '_blank')

            } else {

              let w = window.open('')
              if (r.url.match(/^data:application\/pdf/)) {
                w.document.write('<html><body style="margin:0!important"><embed width="100%" height="100%" src="' + r.url + '" /></body></html>')
              } else {
                w.document.write('<html><body style="margin:0!important"><embed style="max-width: 100%; max-height: 100%;" src="' + r.url + '" /></body></html>')
              }
              w.stop()
            }

          } else {
            window.open(r.url, '_blank')
          }
        }).finally(() => {
          this.loadingProof = false
        })
      },
      isVerified (result) {
        let verified = !!result
        for (let k in result || []) {
          verified = !!result[k]
          if (verified) break
        }
        return verified
      }
    },

  }
</script>
